import { render, staticRenderFns } from "./Animate.vue?vue&type=template&id=45a4ce98&scoped=true&"
import script from "./Animate.vue?vue&type=script&lang=js&"
export * from "./Animate.vue?vue&type=script&lang=js&"
import style0 from "./Animate.vue?vue&type=style&index=0&id=45a4ce98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a4ce98",
  null
  
)

export default component.exports